// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3ftfw","col":"styles_col__7DpuG"};